<template>
  <div v-html="renderedMD" class="tzMarkdown" />
</template>

<script>
import marked from 'marked';
export default {
  name: 'TzMarkdown',
  props: {
    content: {
      type: [String],
      required: true
    }
  },
  computed: {
    renderedMD: function() {
      return this.content ? marked(this.content) : '';
    }
  },
  methods: {}
};
</script>
